function formatProductCode(product) {
  return product.code;
}

export { formatProductCode };
